import React, { useEffect, useState, useReducer, useCallback } from 'react'
import { Flex } from 'reflexbox'
import { toast } from 'react-toastify'

import Loader from 'components/Loader'
import Pagination from 'components/Pagination'
import { Title, Text } from 'components/Typography'
import { Download } from 'components/Icons'

import { reducer } from 'helpers/loadingReducer'
import { getImages } from 'services/catalog'

import { ImageContainer } from './styles'

const Catalog = () => {
  const [requestStatus, dispatch] = useReducer(reducer, { isLoading: true, error: false })
  const [images, setImages] = useState(null)
  const [paginationOptions, setPaginationOptions] = useState()
  const [paginationParams, setPaginationParams] = useState({ page: 1, limit: 6 })

  const pagination = useCallback(config => setPaginationParams(config), [])

  useEffect(() => {
    const getCatalogImages = async () => {
      try {
        const { data } = await getImages(paginationParams)
        setImages(data.data)
        setPaginationOptions({
          selected_page: data.page,
          limit: data.limit,
          total_pages: data.total_pages,
        })

        dispatch({ type: 'success' })
      } catch (e) {
        console.log(e)
        toast.error('Não foi possivel carregar o catálogo no momento.')
        dispatch({ type: 'error' })
      }
    }

    getCatalogImages()
  }, [paginationParams])

  return (
    <Flex width={1} flexDirection='column'>
      <Title as='h3'>Imagens para divulgação</Title>
      {requestStatus.isLoading ? (
        <Flex height='50vh' width={1} justifyContent='center'>
          <Loader />
        </Flex>
      ) : requestStatus.error ? (
        <Text>Nenhum dado encontrado.</Text>
      ) : (
        <Flex flexDirection='column' width={1} justifyContent='center' alignItems='center'>
          <Flex width={1} flexWrap='wrap'>
            {images &&
              images.map(image => (
                <ImageContainer key={image.id} image={image.file}>
                  <a href={image.file} target='blank' download>
                    <Download />
                  </a>
                </ImageContainer>
              ))}
          </Flex>
          <Pagination paginationOptions={paginationOptions} pagination={pagination} elementsPerPage={6} />
        </Flex>
      )}
    </Flex>
  )
}

export default Catalog
